export const RESUME_SELECTOR_LIMIT_TO_COLLAPSE = 3;
